import { EntityBryntumTab } from "./EntityBryntumTab";
import { Tabs, TabsContent } from "@/modern/components/ui/tabs";
import { cn } from "@/modern/utils";
import { EntityTitleBar } from "./components/EntityTitleBar";
import { EntityPillBar } from "./components/EntityPillBar";
import { Timeline } from "../entityViews/timeline/Timeline";
import { EntityManagerProvider, useEntityManagerContext } from "./context/EntityManagerContext";

const EntityManager = () => {
  const { record, entityConfig, activeTab, setActiveTab } = useEntityManagerContext();

  return (
    <div className="entity-page flex bg-background h-full flex-1 w-full min-w-0 [&_.swivu-modern-grid-tbar]:bg-transparent absolute inset-0" style={{ fontSize: "16px" }}>
      <Tabs
        defaultValue="0"
        className="flex-1 min-w-0 grid [grid-template-areas:'header_header'_'timeline_panel']
            [grid-template-columns:minmax(250px,20%)_auto]
            [grid-template-rows:auto_1fr]
        "
        onValueChange={setActiveTab}
      >
        <div className="[grid-area:header] border-b min-w-0">
          <EntityTitleBar />
          <EntityPillBar record={record} entityConfig={entityConfig} />
        </div>
        <main className="flex flex-col [grid-area:panel] overflow-y-auto">
          {entityConfig.tabs.map(({ type, Tab, ...tabConfig }, index) => {
            const isActiveTab = activeTab === String(index);
            return (
              <TabsContent key={index} value={index.toString()} className={cn("h-full")} forceMount={true} hidden={!isActiveTab}>
                {type === "bryntum" ? (
                  <EntityBryntumTab widget={Tab} hidden={!isActiveTab} {...tabConfig} />
                ) : (
                  <Tab />
                )}
              </TabsContent>
            );
          })}
        </main>
        <div className="[grid-area:timeline] flex min-h-0 flex-col flex-1">
          <Timeline />
        </div>
      </Tabs>
    </div>
  );
};

export const EntityManagerView = () => {
  return (
    <EntityManagerProvider>
      <EntityManager />
    </EntityManagerProvider>
  );
};
